import React, { useState } from 'react';
import { motion } from 'framer-motion';

const GalleryImage = ({ image, onClick, delay = 0 }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: delay * 0.1 }}
      className="relative aspect-w-4 aspect-h-3 rounded-xl overflow-hidden bg-gray-100"
      onClick={(e) => {
        e.stopPropagation();
        onClick(image);
      }}
    >
      {!isLoaded && !hasError && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin" />
        </div>
      )}
      
      {hasError ? (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="text-center p-4">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p className="mt-2 text-sm text-gray-500">Nie udało się załadować obrazu</p>
          </div>
        </div>
      ) : (
        <img
          src={image.url}
          alt=""
          className={`w-full h-full object-cover transition-all duration-300 cursor-pointer
            ${isLoaded ? 'opacity-100 hover:scale-105' : 'opacity-0'}
            ${isClicked ? 'scale-125' : ''}`}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
          onClick={(e) => {
            e.stopPropagation();
            setIsClicked(!isClicked);
            onClick(image);
          }}
        />
      )}
      
    </motion.div>
  );
};

const GalleryGrid = ({ images, onImageClick }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
      {images.map((image, index) => (
        <GalleryImage
          key={image.id}
          image={image}
          onClick={onImageClick}
          delay={index}
        />
      ))}
    </div>
  );
};

export default GalleryGrid;
